// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* HTML: <div class="loader"></div> */
.style_loader__01AVV {
  width: 60px;
  aspect-ratio: 1;
  color: #ddedfd;
  background: linear-gradient(currentColor 0 0) 100% 0,
    linear-gradient(currentColor 0 0) 0 100%;
  background-size: 50.1% 50.1%;
  background-repeat: no-repeat;
  animation: style_l7-0__jMVqI 1s infinite steps(1);
}
.style_loader__01AVV::before,
.style_loader__01AVV::after {
  content: "";
  position: absolute;
  inset: 0 50% 50% 0;
  background: currentColor;
  transform: scale(var(--s, 1)) perspective(150px) rotateY(0deg);
  transform-origin: bottom right;
  animation: style_l7-1__sXvr8 0.5s infinite linear alternate;
}
.style_loader__01AVV::after {
  --s: -1, -1;
}
@keyframes style_l7-0__jMVqI {
  0% {
    transform: scaleX(1) rotate(0deg);
  }
  50% {
    transform: scaleX(-1) rotate(-90deg);
  }
}
@keyframes style_l7-1__sXvr8 {
  49.99% {
    transform: scale(var(--s, 1)) perspective(150px) rotateX(-90deg);
    filter: grayscale(0);
  }
  50% {
    transform: scale(var(--s, 1)) perspective(150px) rotateX(-90deg);
    filter: grayscale(0.8);
  }
  100% {
    transform: scale(var(--s, 1)) perspective(150px) rotateX(-180deg);
    filter: grayscale(0.8);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/elements/style.module.css"],"names":[],"mappings":"AAAA,qCAAqC;AACrC;EACE,WAAW;EACX,eAAe;EACf,cAAc;EACd;4CAC0C;EAC1C,4BAA4B;EAC5B,4BAA4B;EAC5B,iDAAoC;AACtC;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,wBAAwB;EACxB,8DAA8D;EAC9D,8BAA8B;EAC9B,2DAA8C;AAChD;AACA;EACE,WAAW;AACb;AACA;EACE;IACE,iCAAiC;EACnC;EACA;IACE,oCAAoC;EACtC;AACF;AACA;EACE;IACE,gEAAgE;IAChE,oBAAoB;EACtB;EACA;IACE,gEAAgE;IAChE,sBAAsB;EACxB;EACA;IACE,iEAAiE;IACjE,sBAAsB;EACxB;AACF","sourcesContent":["/* HTML: <div class=\"loader\"></div> */\n.loader {\n  width: 60px;\n  aspect-ratio: 1;\n  color: #ddedfd;\n  background: linear-gradient(currentColor 0 0) 100% 0,\n    linear-gradient(currentColor 0 0) 0 100%;\n  background-size: 50.1% 50.1%;\n  background-repeat: no-repeat;\n  animation: l7-0 1s infinite steps(1);\n}\n.loader::before,\n.loader::after {\n  content: \"\";\n  position: absolute;\n  inset: 0 50% 50% 0;\n  background: currentColor;\n  transform: scale(var(--s, 1)) perspective(150px) rotateY(0deg);\n  transform-origin: bottom right;\n  animation: l7-1 0.5s infinite linear alternate;\n}\n.loader::after {\n  --s: -1, -1;\n}\n@keyframes l7-0 {\n  0% {\n    transform: scaleX(1) rotate(0deg);\n  }\n  50% {\n    transform: scaleX(-1) rotate(-90deg);\n  }\n}\n@keyframes l7-1 {\n  49.99% {\n    transform: scale(var(--s, 1)) perspective(150px) rotateX(-90deg);\n    filter: grayscale(0);\n  }\n  50% {\n    transform: scale(var(--s, 1)) perspective(150px) rotateX(-90deg);\n    filter: grayscale(0.8);\n  }\n  100% {\n    transform: scale(var(--s, 1)) perspective(150px) rotateX(-180deg);\n    filter: grayscale(0.8);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loader": `style_loader__01AVV`,
	"l7-0": `style_l7-0__jMVqI`,
	"l7-1": `style_l7-1__sXvr8`
};
export default ___CSS_LOADER_EXPORT___;
